import { createBrowserRouter } from "react-router-dom";
import App from "../../App";
import MainLayout from "../../layout/MainLayout/MainLayout";
import AdminLoginRoutes from "../AdminLoginRoutes/AdminLoginRoutes";
import BuyerRoutes from "../BuyerRoutes/BuyerRoutes";
import ProfileDetails from "../../components/ProfileDetails/ProfileDetails";
import DashboardRoutes from "../DashboardRoutes/DashboardRoutes";
import OrderSubcriptionRoutes from "../OrderSubscriptionRoutes/OrderSubcriptionRoutes";
import OSPRoutes from "../OSPRoutes/OSPRoutes";
import ProductsRoutes from "../ProductRoutes/ProductRoutes";
import ProductRfqQuoteRoutes from "../ProductRfqQuoteRoutes/ProductRfqQuoteRoutes";
import ProductSellerRoutes from "../ProductSellersRoutes/ProductSellerRoutes";
import ServiceRfqQuoteRoutes from "../ServiceRfqQuoteRoutes/ServiceRfqQuoteRoutes";
import ServicesRoutes from "../ServiceRoutes/ServiceRoutes";
import SettingsPageRoutes from "../SettingsPageRoutes/SettingsPageRoutes";
import TicketsRoutes from "../TicketRoutes/TicketRoutes";
import WebsiteSettingsRoutes from './../WebSettingsRoutes/WebsiteSettingsRoutes';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      // Merge into the same children array
      ...AdminLoginRoutes,
      {
        path: "admin-dashboard",
        element: <MainLayout />,
        children: [
          {
            path: "profiledetails",
            element: <ProfileDetails />,
          },
          ...BuyerRoutes,
          ...DashboardRoutes,
          ...OrderSubcriptionRoutes,
          ...OSPRoutes,
          ...ProductRfqQuoteRoutes,
          ...ProductSellerRoutes,
          ...ServiceRfqQuoteRoutes,
          ...ServicesRoutes,
          ...SettingsPageRoutes,
          ...TicketsRoutes,
          ...ProductsRoutes,
          ...WebsiteSettingsRoutes,
        ],
      },
    ],
  },
]);

export default router;
